import { ICertificate, Certificate } from './certificate.model';
import { IExamAttempt, ExamAttempt } from './exam-attempt.model';
import { IExamQuestion, ExamQuestion } from './exam-question.model';

export interface IExamInstanceData {
  certificate: ICertificate;
  examAttempt: IExamAttempt | null;
  questions: IExamQuestion[];
}

export class ExamInstanceData {
  certificate: Certificate;
  examAttempt: ExamAttempt | null;
  questions: ExamQuestion[];

  constructor(data: IExamInstanceData) {
    this.certificate = new Certificate(data.certificate);
    this.examAttempt = data.examAttempt ? new ExamAttempt(data.examAttempt) : null;
    this.questions = data.questions.map(q => new ExamQuestion(q));
  }
}
